<template>
  <div class="mt-5">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12 col-lg-10">
          <div class="card">
            <div class="d-flex">
              <h3 class="font-weight-light ml-3 mr-auto">Pagamento de Conta</h3>
              <WhiteLabel class="ml-auto mt-1 pull-right mr-4">
                <router-link :to="{ name: 'bills-payment' }">
                  <i class="icon-arrow-left-circle"></i> Voltar
                </router-link>
              </WhiteLabel>
            </div>
            <hr />
            <div class="card-content">
              <div class="form-row col-12">
                <div class="col-12 col-w-full">
                  <WhiteLabel>
                    <h4 class="font-weight-light blue">
                      Comprovante de Pagamento de Boleto
                    </h4>
                  </WhiteLabel>
                </div>
                <div class="form-group col-12 col-w-full col-lg-6 col-xl-6 mb-4">
                  <label>Dados da conta debitada / Pagador Final</label>
                  <p></p>
                </div>
                <div class="form-row col-12">
                  <div class="form-group col-12 col-w-full col-lg-6 col-xl-6 mb-4">
                    <label>CPF/CNPJ:</label>
                    <p> 17.819.084/0001-92 </p>
                  </div>
                  <div class="form-group col-12 col-w-full col-lg-6 col-xl-6 mb-4">
                    <label>Nome:</label>
                    <p> Paggcerto S/A </p>
                  </div>
                </div>
                <div class="form-row col-12">
                  <div class="col-12 col-w-full">
                    <WhiteLabel>
                      <h4 class="font-weight-light blue">Dados do Pagamento</h4>
                    </WhiteLabel>
                  </div>
                  <div class="form-group col-12 col-w-full col-lg-12 col-xl-12 mb-4">
                    <label>Instituição Emissora:</label>
                    <p> {{ getValueOf('IssuerInstitutionName') }} </p>
                  </div>
                  <div class="form-group col-12 col-w-full col-lg-12 col-xl-12 mb-4">
                    <label>Código de barras</label>
                    <p>{{ formatStringInFourParts(paymentDetail.barCode) }}</p>
                  </div>
                  <div class="form-group col-12 col-w-full col-lg-6 col-xl-6 mb-4">
                    <label>Beneficiário</label>
                    <p>{{ paymentDetail.recipientName }}</p>
                  </div>
                  <div class="form-group col-12 col-w-full col-lg-6 col-xl-6 mb-4">
                    <label>CPF/CNPJ do beneficiário:</label>
                    <p>{{ paymentDetail.recipientDocument }}</p>
                  </div>
                  <div class="form-group col-12 col-w-full col-lg-6 col-xl-6 mb-4">
                    <label>Pagador</label>
                    <p>  {{ getValueOf('PayerName') }}</p>
                  </div>
                  <div class="form-group col-12 col-w-full col-lg-6 col-xl-6 mb-4">
                    <label>CPF/CNPJ do Pagador:</label>
                    <p>{{ formatDocument(getValueOf('PayerDocument')) }}</p>
                  </div>
                  <div class="form-group col-12 col-lg-6 mb-4">
                    <label> Data de Vencimento </label>
                    <p>{{ paymentDetail.dueDate | moment('DD/MM/YYYY') }}</p>
                  </div>
                  <div class="form-group col-12 col-w-full col-lg-6 col-xl-6 mb-4">
                    <label>Valor</label>
                    <p>
                      {{
                        paymentDetail.value
                          | currency('R$ ', 2, {
                              decimalSeparator: ',',
                              thousandsSeparator: '.',
                            })
                      }}
                    </p>
                  </div>
                  <div class="form-group col-12 col-w-full col-lg-6 col-xl-6 mb-4">
                    <label>Desconto</label>
                    <p>
                      {{
                        paymentDetail.discount
                          | currency('R$ ', 2, {
                              decimalSeparator: ',',
                              thousandsSeparator: '.',
                            })
                      }}
                    </p>
                  </div>
                  <div class="form-group col-12 col-w-full col-lg-6 col-xl-6 mb-4">
                    <label>Mora/Multa</label>
                    <p>
                      {{
                        paymentDetail.penalty
                          | currency('R$ ', 2, {
                              decimalSeparator: ',',
                              thousandsSeparator: '.',
                            })
                      }}
                    </p>
                  </div>
                  <div class="form-group col-12 col-w-full col-lg-12 col-xl-12 mb-4">
                    <label>Valor pago</label>
                    <p>
                      {{
                        paymentDetail.valuePaid
                          | currency('R$ ', 2, {
                              decimalSeparator: ',',
                              thousandsSeparator: '.',
                            })
                      }}
                    </p>
                  </div>
                  <div class="form-group col-12 col-w-full col-lg-6 col-xl-6 mb-4">
                    <label>Beneficiário Final</label>
                    <p>{{ paymentDetail.finalRecipientName }}</p>
                  </div>
                  <div class="form-group col-12 col-w-full col-lg-6 col-xl-6 mb-4">
                    <label>CPF/CNPJ do beneficiário final</label>
                    <p>{{ formatDocument(paymentDetail.finalRecipientDocument) }}</p>
                  </div>
                  <div class="form-group col-12 col-w-full col-lg-6 col-xl-6 mb-4">
                    <label>Data e hora da transação</label>
                    <p>{{ paymentDetail.createdAt | moment('DD/MM/YYYY HH:mm:ss') }}</p>
                  </div>
                  <div class="form-group col-12 col-w-full col-lg-6 col-xl-6 mb-4">
                    <label>Via</label>
                    <p>Internet</p>
                  </div>
                </div>
                <div class="form-row col-12">
                  <div class="form-group col-12 col-w-full col-lg-6 col-xl-6 mb-4">
                    <label>NSU</label>
                    <p>{{ getValueOf('Nsu') }}</p>
                  </div>
                  <div class="col-12 col-w-full">
                    <label>
                      RECIDO POR CORRESPONDENTE BANCÁRIO DIGITAL E PROCESSADO POR ITAÚ UNIBANCO S.A.
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import paymentDetailsCommonMethods from './paymentDetailsCommonMethods.js';

export default {
  name: 'AppPaymentDetailsTypeBoleto',
  mixins: [paymentDetailsCommonMethods],
  props: {
    paymentDetail: {
      type: Object,
      required: true,
      validator(value) {
        return (
          value &&
          typeof value.barCode === 'string' &&
          'valuePaid' in value &&
          'preset' in value
        );
      },
    },
  },
};
</script>
